/** Grymwyrd - traducción al español europeo para el layout compartido (TopNav + Footer). */
export const layoutEs = {
  'layout.nav.veil': 'El Velo',
  'layout.nav.encyclopedia': 'Enciclopedia',
  'layout.nav.world': 'El Mundo',
  'layout.nav.play': 'Jugar',
  'layout.nav.books': 'Libros y Reglas',
  'layout.nav.community': 'Comunidad',
  'layout.nav.homeAria': 'Inicio de {world}',
  'layout.nav.search': 'Buscar en la enciclopedia',
  'layout.nav.unmute': 'Activar ambiente sonoro',
  'layout.nav.mute': 'Desactivar ambiente sonoro',
  'layout.nav.coinBalance': 'Saldo de monedas',
  'layout.nav.signedInAs': 'Sesión iniciada como {name}',
  'layout.nav.enter': 'Entra en {world}',
  'layout.nav.toggleMenu': 'Abrir/cerrar menú',
  'layout.nav.dashboard': 'Mi {world} ({name})',
  'layout.nav.signOut': 'Cerrar sesión',

  'layout.footer.hideLinks': 'Ocultar enlaces del sitio',
  'layout.footer.showLinks': 'Enlaces del sitio y legal',
  'layout.footer.tagline': 'El mundo de horror fantástico viviente donde tu leyenda se convierte en canon.',
  'layout.footer.explore': 'Explorar',
  'layout.footer.legal': 'Legal',
  'layout.footer.accessibility': 'Accesibilidad',
  'layout.footer.encyclopedia': 'Enciclopedia',
  'layout.footer.world': 'El Mundo',
  'layout.footer.playVtt': 'Jugar (VTT)',
  'layout.footer.books': 'Libros y Reglas',
  'layout.footer.terms': 'Términos de Servicio',
  'layout.footer.privacy': 'Política de Privacidad',
  'layout.footer.canonRelease': 'Liberación de Presentación de Canon',
  'layout.footer.aiPolicy': 'Política de IA',
  'layout.footer.cookies': 'Preferencias de Cookies',
  'layout.footer.copyright': '© 2026 GameCodex',
}
